import { render, staticRenderFns } from "./PurchaseItemBody.vue?vue&type=template&id=5890b3ae"
import script from "./PurchaseItemBody.vue?vue&type=script&lang=js"
export * from "./PurchaseItemBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports